export const ACCOUNT_LINKS_BORDER_COLOR = 'black';
export const ACCOUNT_LINKS_DISPLAY_SECTION_HEADINGS = false;
export const ACCOUNT_LINKS_DISPLAY_LANGUAGE_SELECTOR = true;
export const ACCOUNT_DISPLAY_SIGN_UP_HEADLINE = false;
export const isAccountActionsEnabled = (enableSignUp?: boolean) => !!enableSignUp;
export const SUBMIT_FEEDBACK_INTL_KEY = 'needHelp';
